/* eslint-disable no-multiple-empty-lines */
import {getApp, getApps, initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getFirestore, initializeFirestore} from "firebase/firestore";
import {getFunctions} from "firebase/functions";
import {getStorage} from "firebase/storage";

export const credentials = {
    apiKey: "AIzaSyBoVXTS39oQdyot9_MAVF3_4qwben9fy8o",
    authDomain: "scimos-cf7ba.firebaseapp.com",
    projectId: "scimos-cf7ba",
    storageBucket: "scimos-cf7ba.appspot.com",
    messagingSenderId: "683985916377",
    appId: "1:683985916377:web:1737416e8f6058d3ee09c8",
    measurementId: "G-T27PRNBLPV",
};

const firebaseConfig = !getApps().length ? initializeApp(credentials) : getApp();

initializeFirestore(firebaseConfig, {
    ignoreUndefinedProperties: true,
});

export const auth = getAuth(firebaseConfig);
export const db = getFirestore(firebaseConfig);
export const functions = getFunctions(firebaseConfig, "europe-west2");
export const storage = getStorage(firebaseConfig);

// connectFunctionsEmulator(functions, "localhost", 5001);


